// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chikorita: PokeData = {
  "id": 152,
  "name": "chikorita",
  "height": 9,
  "weight": 64,
  "base_experience": 64,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "growl",
    "leech-seed",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "light-screen",
    "reflect",
    "giga-drain",
    "safeguard",
    "sweet-scent",
    "synthesis",
    "nature-power",
    "aromatherapy",
    "magical-leaf",
    "natural-gift"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "growl",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "reflect",
    "synthesis",
    "aromatherapy",
    "vine-whip",
    "grassy-terrain",
    "overgrowth",
    "power-whip"
  ],
  "evolution_chain": {
    "id": 79,
    "item": null,
    "species": [
      {
        "name": "chikorita",
        "order": 184,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bayleef",
        "order": 185,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 152,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "meganium",
        "order": 186,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 153,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 45,
    "ability_power": 49
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
